import React, { useState } from 'react';
import TemplateManagement from './TemplateManagement';
import CredentialManagement from './CredentialManagement';
import IdpSetup from './idp/IdpSetup';

const IntegrationManagement = () => {
  const [activeTab, setActiveTab] = useState('templates');

  const renderTabContent = () => {
    switch (activeTab) {
      case 'templates':
        return <TemplateManagement />;
      case 'credentials':
        return <CredentialManagement />;
      case 'idp-setup':
        return <IdpSetup />;
      default:
        return <TemplateManagement />;
    }
  };

  return (
    <div className="integration-management">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="peers ai-c jc-sb fxw-nw mB-30">
              <div className="peer">
                <h4 className="c-grey-900 mT-10 mB-0">Integration Management</h4>
              </div>
              <div className="peer">
                <div className="btn-group" role="group" aria-label="Integration Tabs">
                  <button
                    className={`btn ${activeTab === 'templates' ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => setActiveTab('templates')}
                  >
                    Templates
                  </button>
                  <button
                    className={`btn ${activeTab === 'credentials' ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => setActiveTab('credentials')}
                  >
                    Credentials
                  </button>
                  <button
                    className={`btn ${activeTab === 'idp-setup' ? 'btn-primary' : 'btn-outline-primary'}`}
                    onClick={() => setActiveTab('idp-setup')}
                  >
                    IDP Setup
                  </button>
                </div>
              </div>
            </div>
            <div className="bgc-white bd bdrs-3 p-20 mB-20">
              {renderTabContent()}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntegrationManagement;
